import { isRoutePathname } from './utils.js'

const BASE = '/settings/moderation' as const

export const moderationRoutes = {
  root: BASE,
  space: (spaceId: string) => `${BASE}/${spaceId}`,
} as const

export const isModerationRoutePathname = (pathname: string) =>
  isRoutePathname({ pathname, route: moderationRoutes.root })
